import { createAction } from "redux-actions";

import { IClientPatch, IPatchAction } from "../../../components/course-author/helpers/patches";
import { IUsersUIData } from "../../../parsers/resolve";
import { IClass, ICourse } from "../../types/common";

export interface IClassManagementAndUsers {
  class: IClass;
  allManagers: IUsersUIData[];
  allMembers: IUsersUIData[];
}

export enum Action {
  FETCH_INITIAL_DATA = "FETCH_INITIAL_DATA",
  HANDLE_FETCH_INITIAL_DATA_FAILURE = "HANDLE_FETCH_INITIAL_DATA_FAILURE",
  HANDLE_FETCH_INITIAL_DATA_SUCCESS = "HANDLE_FETCH_INITIAL_DATA_SUCCESS",
  DELETE_CLASS = "DELETE_CLASS",
  HANDLE_DELETE_CLASS_FAILURE = "HANDLE_DELETE_CLASS_STATE",
  HANDLE_DELETE_CLASS_SUCCESS = "HANDLE_DELETE_CLASS_SUCCESS",
  PATCH_CLASS_REQUEST = "PATCH_CLASS_REQUEST",
  PATCH_CLASS_REQUEST_FAILURE = "PATCH_CLASS_REQUEST_FAILURE",
  PATCH_CLASS_REQUEST_SUCCESS = "PATCH_CLASS_REQUEST_SUCCESS",
  REFRESH_CLASS = "REFRESH_CLASS_REQUEST",
  REFRESH_CLASS_FAILURE = "REFRESH_CLASS_REQUEST_FAILURE",
  REFRESH_CLASS_SUCCESS = "REFRESH_CLASS_REQUEST_SUCCESS",
  MOUNT = "MOUNT",
  UNMOUNT = "UNMOUNT",
}

export interface IInitialData {
  class: IClass;
  allCourses: ICourse[];
  allMembers: IUsersUIData[];
  allManagers: IUsersUIData[];
}

export const mount = createAction<string>(Action.MOUNT);
export const unmount = createAction<void>(Action.UNMOUNT);
export const fetchInitialData = createAction<void>(Action.FETCH_INITIAL_DATA);
export const handleFetchInitialDataSuccess = createAction<IInitialData>(Action.HANDLE_FETCH_INITIAL_DATA_SUCCESS);
export const handleFetchInitialDataFailure = createAction<{ message: string }>(
  Action.HANDLE_FETCH_INITIAL_DATA_FAILURE
);
export const deleteClass = createAction<void>(Action.DELETE_CLASS);
export const handleDeleteClassFailure = createAction<{ message: string }>(Action.HANDLE_DELETE_CLASS_FAILURE);
export const handleDeleteClassSuccess = createAction<void>(Action.HANDLE_DELETE_CLASS_SUCCESS);
export const patchClassRequest = createAction<IClientPatch<IPatchAction>>(Action.PATCH_CLASS_REQUEST);
export const patchClassRequestFailure = createAction<{ message: string }>(Action.PATCH_CLASS_REQUEST_FAILURE);
export const patchClassRequestSuccess = createAction<string>(Action.PATCH_CLASS_REQUEST_SUCCESS);
export const refreshClass = createAction<void>(Action.REFRESH_CLASS);
export const refreshClassFailure = createAction<{ message: string }>(Action.REFRESH_CLASS_FAILURE);
export const refreshClassSuccess = createAction<IClassManagementAndUsers>(Action.REFRESH_CLASS_SUCCESS);
